import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpeechBubbleArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 10,
	fill: "none",
	viewBox: "0 0 14 10",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#F5F5F5",
		d: "M0.612823 0.522561C2.18412 3.09054 8.69232 4.09054 11.6947 3.09054C13.2064 5.20096 14.9651 9.61771 9.19458 9.09054C0.88524 8.33143 -1.21801 -2.46958 0.612823 0.522561Z"
	})
});
const ForwardRef = forwardRef(SvgSpeechBubbleArrow);
export default ForwardRef;
